export default {
  title: 'Task Management',
  subTitle: 'You haven\'t set up any tasks yet.',
  buttonTitle: 'Create a new task',
  createTaskModalTitle: 'Add a new task',
  editTaskModalTitle: 'Edit task',
  selectEmployee: 'Select employee',
  name: 'Name',
  taskRelatedTo: 'Task related to',
  taskRelatedToDescription: 'Select the type and specific assessment this task relates to.',
  status: 'Status',
  relatedTo: 'Related to',
  relatedToMA: 'Related MA to',
  commentModalTitle: 'Add a comment',
  commentModalDescription: 'Type your comment here',
  tableTitle: 'Tasks by Others in Same Type:',
  commentRequired: 'Comment is required for this status.',
  commentOptional: 'Comment optional for this status.',
  taskHasBeenAdded: 'Task has been added',
  creationProgressWillBeLost: 'Creation progress will be lost.',
  discardProgress: 'Creating a new user will discard the progress made in creating the task. '
  + 'Are you sure you want to continue?',
  noActivities: 'There aren\'t any activities yet.',
  noComments: 'There aren\'t any comments yet.',
  days: 'days',
  duration: 'Duration',
  changeTo: 'change to',
  startDate: 'Start date:',
  endDate: 'End date:',
  description: 'Description:',
  commentToChanging: 'Comment to changing:',
  unselectAll: 'Unselect all',
  taskChangedTo: 'changed',
  taskName: 'Task Name:',
  priority: 'Priority:',
  userAssigned: 'User assigned:',
  userRemoved: 'User removed:',
  noFilesAttached: "There aren't any files attached yet.",
  fields: {
    name: 'Task Name',
    relateTo: 'Task Relate to',
    assignedTo: 'Assigned to',
    description: 'Description',
    startDate: 'Start date',
    endDate: 'End date',
    duration: 'Duration',
    attachFile: 'Choose file or drag and drop here',
    dropFiles: 'Drop files here',
    attachments: 'Attachments',
    priority: 'Priority',
    status: 'Status',
    taskName: 'Task Name',
    relatedTo: 'Related to',
    actions: 'Actions',
    attachedFile: 'Attached file',
    createdDate: 'Created Date',
    closedDate: 'Closed Date',
  },
  placeholder: {
    name: 'Task name',
    relateTo: 'Select type',
    assignedTo: 'Select employee',
    assignToSelectedUsers: 'Selected {{count}} employees',
    description: 'Add description here...',
    startDate: 'mm-dd-yyyy',
    endDate: 'mm-dd-yyyy',
    duration: 'Duration (days)',
    priority: 'Select priority',
  },
  hint: {
    attachments: 'Choose file or drag and drop here',
  },
  statusOptions: {
    created: 'Created',
    assigned: 'Assigned',
    'in-progress': 'In Progress',
    completed: 'Completed',
    deferred: 'Deferred',
    blocked: 'Blocked',
    cancelled: 'Cancelled',
  },
  selectAll: 'Select all',
};
